module.exports = __webpack_public_path__ + "img/language_icon_v3.5d42f6fb.svg";